"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SelloutReleaseType_1 = require("../../../release/model/sellout/SelloutReleaseType");
/**
 * Represents top filter for new sellout impact report.
 *
 * @author Jan Prokop
 */


var SelloutImpactReportFilterDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactReportFilterDTO, _DomainObject_1$Domai);

  function SelloutImpactReportFilterDTO() {
    var _this;

    _classCallCheck(this, SelloutImpactReportFilterDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportFilterDTO).apply(this, arguments));
    _this.categoryIds = null;
    _this.selloutTypes = null;
    _this.siteIds = null;
    _this.productExternalIds = null;
    _this.supplierIds = null;
    _this.repriced = null;
    return _this;
  }

  _createClass(SelloutImpactReportFilterDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutImpactReportFilterDTO().copyMulti(mat);
    }
  }]);

  return SelloutImpactReportFilterDTO;
}(DomainObject_1.DomainObject);

exports.SelloutImpactReportFilterDTO = SelloutImpactReportFilterDTO;

SelloutImpactReportFilterDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutImpactReportFilterDTO.name);
  return {
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    categoryIds: builder.opt(builder.listOf(builder.lookup('categoryIds', CodebookLookupSequence_1.CodebookLookupSequence.Category))),
    selloutTypes: builder.opt(builder.listOf(builder.senum('selloutTypes', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType))),
    priceZoneId: builder.lookup('priceZoneId', CodebookLookupSequence_1.CodebookLookupSequence.PriceZone),
    siteIds: builder.opt(builder.listOf(builder.lookup('siteIds', CodebookLookupSequence_1.CodebookLookupSequence.InternalSites))),
    productExternalIds: builder.opt(builder.listOf(builder.str('productExternalIds'))),
    supplierIds: builder.opt(builder.listOf(builder.lookup('supplierIds', CodebookLookupSequence_1.CodebookLookupSequence.Supplier))),
    repriced: builder.opt(builder.listOf(builder.num('repriced')))
  };
}();